/*
 * Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {User} from '../../shared/model/user';


@Component({
    selector: 'gm-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @Input() sidebarOpen: boolean;
  @Input() useSidebar: boolean;
  @Output() sidebarOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  firstName = 'Guest';
  lastName = 'Guest';
  zID = 'Guest';
  roles: string[] = [];
  groups: string[] = [];
  loggedInUserObject: User;

  constructor() {
  }

  ngOnInit() {
  }

}
